export default __webpack_public_path__ + "static/media/polyester-banner.1e3caee4.jpg";